import { gql } from '@apollo/client'

export const GET_SIGNED_URLS = gql`
  query getSignedUrls($query: S3FileInput!) {
    getSignedUrls(query: $query)
  }
`
